import LegalLayout from './LegalLayout';

export default function CookiePolicy() {
  return (
    <LegalLayout title="Cookie Policy" lastUpdated="2026-06-18">
      <p>
        This Cookie Policy explains how RentNova uses cookies and similar
        technologies (collectively, "cookies") when you visit rentnova.app.
      </p>

      <h2>1. What is a cookie?</h2>
      <p>
        A cookie is a small text file that a website stores on your browser. It
        lets the site remember information about your visit, like your
        preferred language and whether you're signed in.
      </p>

      <h2>2. Categories of cookies we use</h2>

      <h3>Strictly necessary (always on)</h3>
      <p>
        Required for the Service to function. You cannot opt out of these
        because the Service would not work without them.
      </p>
      <table>
        <thead>
          <tr><th>Cookie / storage</th><th>Purpose</th><th>Retention</th></tr>
        </thead>
        <tbody>
          <tr>
            <td><code>sb-*-auth-token</code></td>
            <td>Authentication. Keeps you signed in.</td>
            <td>Session + refresh</td>
          </tr>
          <tr>
            <td><code>i18nextLng</code></td>
            <td>Language preference (EN / SK / DE).</td>
            <td>Persistent (localStorage)</td>
          </tr>
          <tr>
            <td><code>rentnova_consent</code></td>
            <td>Stores your cookie-banner choice so we don't ask again.</td>
            <td>12 months (localStorage)</td>
          </tr>
        </tbody>
      </table>

      <h3>Analytics (optional, off by default)</h3>
      <p>
        Privacy-friendly aggregate analytics — no cross-site tracking, no
        personal profiles. Loaded only after you accept.
      </p>
      <table>
        <thead>
          <tr><th>Provider</th><th>Purpose</th><th>Retention</th></tr>
        </thead>
        <tbody>
          <tr>
            <td>Plausible Analytics</td>
            <td>Aggregate page-view counts. No cookies set; uses
              first-party storage only.</td>
            <td>—</td>
          </tr>
        </tbody>
      </table>

      <h3>Error monitoring (optional, off by default)</h3>
      <p>
        Helps us fix bugs by capturing stack traces when something breaks. Does
        not capture form values, passwords, or payment data. Loaded only after
        you accept.
      </p>
      <table>
        <thead>
          <tr><th>Provider</th><th>Purpose</th><th>Retention</th></tr>
        </thead>
        <tbody>
          <tr>
            <td>Sentry</td>
            <td>JavaScript error tracking.</td>
            <td>90 days</td>
          </tr>
        </tbody>
      </table>

      <h3>Payment processing</h3>
      <p>
        Stripe sets its own cookies when you reach a checkout page, for fraud
        prevention and 3-D Secure authentication. These are governed by{' '}
        <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noreferrer">
          Stripe's cookie policy
        </a>.
      </p>

      <h2>3. Managing your choices</h2>
      <p>
        When you first visit, a banner asks for your preference. You can change
        it any time by clearing the <code>rentnova_consent</code> entry from
        your browser's site storage (DevTools → Application → Local Storage)
        and reloading.
      </p>
      <p>
        Most browsers also let you block or delete cookies via their settings.
        Doing so will not affect strictly-necessary functionality but may
        disable analytics and error monitoring.
      </p>

      <h2>4. Changes to this policy</h2>
      <p>
        We may update this Cookie Policy. The "Last updated" date at the top
        reflects the most recent revision.
      </p>
    </LegalLayout>
  );
}
